import { Button, styled } from '@mui/material';

export const ButtonContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '15px',
  width: '100%',
  gap: '12px',
});

type ButtonProps = {
  color?: boolean;
};

export const StyledButton = styled(Button)<ButtonProps>({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  gap: '12px',
  width: '190px',
  height: '40px',
});

export const Input = styled('input')({
  width: '100%',
  padding: '10px 6px',
  borderRadius: '8px',
  border: '1px solid #C2C9D1',
  '-webkit-appearance': 'none',
  color: '#273135',
  '&:focus-visible': {
    outline: '1px solid #BC9A67',
  },
});

export const Select = styled('select')({
  width: '100%',
  padding: '10px 6px',
  borderRadius: '8px',
  border: '1px solid #C2C9D1',
  color: '#273135',
});

export const Label = styled('p')({
  fontFamily: 'Open Sans',
  fontStyle: 'normal',
  fontWeight: 600,
  fontSize: '12px',
  lineHeight: '16px',
  marginBottom: '12px',
  color: 'rgba(0, 0, 0, 0.5)',
});

export const Row = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  gap: '12px',
});

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '15px',
  width: '100%',
  gap: '12px',
  marginBottom: '10px',
});
